import { Collection } from 'modules/core/lib/mobx-rest'

import FavouriteDashboard from 'modules/reports/store/models/FavouriteDashboard'

class FavouriteDashboards extends Collection<FavouriteDashboard> {
  get cacheKey(): string {
    return 'favouriteDashboards'
  }

  model() {
    return FavouriteDashboard
  }
}

const singleton: FavouriteDashboards = new FavouriteDashboards()

export default singleton
